import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

const Customers = () => {
	const theme = useTheme();
	return (
		<Box
			marginBottom={4}
			data-aos="fade-up">
			<Box>
				<Typography
					sx={{
						textTransform: "uppercase",
						fontWeight: "medium",
					}}
					gutterBottom
					color="secondary"
					align="center">
					Trusted by franchise brands across the globe
				</Typography>
			</Box>
			<Box
				display="flex"
				flexWrap="wrap"
				justifyContent="center"
				alignItems="center">
				{[
					"/app-assets/svg/anytimefitness.svg",
					"/app-assets/svg/foreverlawn.svg",
					"/app-assets/svg/bigchicken.svg",
					"/app-assets/svg/orangetheory.svg",
					"/app-assets/svg/f45training.svg",
					"/app-assets/svg/zerolatency.svg",
					"/app-assets/svg/1tomplumber.svg",
					"/app-assets/svg/crushr.svg",
					"/app-assets/svg/janarus.svg",
					"/app-assets/svg/stretchzone.svg",
					"/app-assets/svg/revl.svg",
					"/app-assets/avis-logo-colour.png",
				].map((item, i) => (
					<Box
						maxWidth={180}
						marginTop={4}
						marginRight={8}
						key={i}
						className="largeMarginMobile">
						<Box
							component="img"
							width="100%"
							maxHeight="55px"
							src={item}
							alt="Mango Franchise drives their growth."
							sx={{
								filter:
									theme.palette.mode === "dark"
										? "brightness(0) invert(1)"
										: "brightness(0) invert(0) opacity(0.5)",
							}}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default Customers;
